import { useCallback, useState } from 'react';
import useEventListener from './useEventListener';
var isWindowDefined = typeof window !== 'undefined';
/**
 * Returns the interior width of the window in pixels.
 *
 * @returns {number} Width of the window in pixels
 */

export default function useWindowWidth() {
  var _useState = useState(isWindowDefined ? window.innerWidth : null),
      windowWidth = _useState[0],
      setWindowWidth = _useState[1];

  var getWindowWidth = useCallback(function () {
    return setWindowWidth(window.innerWidth);
  }, []);
  useEventListener(isWindowDefined ? window : null, 'resize', getWindowWidth);
  return windowWidth;
}